import { TAgent } from '../RecordEvent'

function createGoogleAnalytics<T extends Record<string, unknown>>(): TAgent<T, keyof T> {
  // 用于过滤掉不需要的事件，只保留需要的事件
  const agentIgnoreEventName: (keyof T)[] = ['demoToBeIgnored']
  return {
    name: 'googleAnalytics',
    handleEvent(eventName, originEventValue?) {
      if (agentIgnoreEventName.includes(eventName as string)) return
      try {
        // 以下处理谷歌打点逻辑
        let eventValue
        // if (eventName === 'Purchase') {
        //   eventValue = {
        //     value: originEventValue?.amount || 0,
        //     currency: 'VND',
        //   }
        // }
        window.gtag?.('event', eventName as string, eventValue || originEventValue)
      } catch (e) {
        console.error(e)
      }
    },
  }
}

export default createGoogleAnalytics
